module.exports = __webpack_public_path__ + "img/productHSE_81.703b9b5e.png";